(() => {
var $155dc9bd86a2a7f5$var$e, $155dc9bd86a2a7f5$var$n, $155dc9bd86a2a7f5$var$t, $155dc9bd86a2a7f5$var$r, $155dc9bd86a2a7f5$var$i, $155dc9bd86a2a7f5$var$a = -1, $155dc9bd86a2a7f5$var$o = function(e) {
    addEventListener("pageshow", function(n) {
        n.persisted && ($155dc9bd86a2a7f5$var$a = n.timeStamp, e(n));
    }, !0);
}, $155dc9bd86a2a7f5$var$c = function() {
    return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, $155dc9bd86a2a7f5$var$u = function() {
    var e = $155dc9bd86a2a7f5$var$c();
    return e && e.activationStart || 0;
}, $155dc9bd86a2a7f5$var$f = function(e, n) {
    var t = $155dc9bd86a2a7f5$var$c(), r = "navigate";
    $155dc9bd86a2a7f5$var$a >= 0 ? r = "back-forward-cache" : t && (document.prerendering || $155dc9bd86a2a7f5$var$u() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : t.type && (r = t.type.replace(/_/g, "-")));
    return {
        name: e,
        value: void 0 === n ? -1 : n,
        rating: "good",
        delta: 0,
        entries: [],
        id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
        navigationType: r
    };
}, $155dc9bd86a2a7f5$var$s = function(e, n, t) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            var r = new PerformanceObserver(function(e) {
                Promise.resolve().then(function() {
                    n(e.getEntries());
                });
            });
            return r.observe(Object.assign({
                type: e,
                buffered: !0
            }, t || {})), r;
        }
    } catch (e) {}
}, $155dc9bd86a2a7f5$var$d = function(e, n, t, r) {
    var i, a;
    return function(o) {
        n.value >= 0 && (o || r) && ((a = n.value - (i || 0)) || void 0 === i) && (i = n.value, n.delta = a, n.rating = function(e, n) {
            return e > n[1] ? "poor" : e > n[0] ? "needs-improvement" : "good";
        }(n.value, t), e(n));
    };
}, $155dc9bd86a2a7f5$var$l = function(e) {
    requestAnimationFrame(function() {
        return requestAnimationFrame(function() {
            return e();
        });
    });
}, $155dc9bd86a2a7f5$var$p = function(e) {
    var n = function(n) {
        "pagehide" !== n.type && "hidden" !== document.visibilityState || e(n);
    };
    addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, $155dc9bd86a2a7f5$var$v = function(e) {
    var n = !1;
    return function(t) {
        n || (e(t), n = !0);
    };
}, $155dc9bd86a2a7f5$var$m = -1, $155dc9bd86a2a7f5$var$h = function() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
}, $155dc9bd86a2a7f5$var$g = function(e) {
    "hidden" === document.visibilityState && $155dc9bd86a2a7f5$var$m > -1 && ($155dc9bd86a2a7f5$var$m = "visibilitychange" === e.type ? e.timeStamp : 0, $155dc9bd86a2a7f5$var$T());
}, $155dc9bd86a2a7f5$var$y = function() {
    addEventListener("visibilitychange", $155dc9bd86a2a7f5$var$g, !0), addEventListener("prerenderingchange", $155dc9bd86a2a7f5$var$g, !0);
}, $155dc9bd86a2a7f5$var$T = function() {
    removeEventListener("visibilitychange", $155dc9bd86a2a7f5$var$g, !0), removeEventListener("prerenderingchange", $155dc9bd86a2a7f5$var$g, !0);
}, $155dc9bd86a2a7f5$var$E = function() {
    return $155dc9bd86a2a7f5$var$m < 0 && ($155dc9bd86a2a7f5$var$m = $155dc9bd86a2a7f5$var$h(), $155dc9bd86a2a7f5$var$y(), $155dc9bd86a2a7f5$var$o(function() {
        setTimeout(function() {
            $155dc9bd86a2a7f5$var$m = $155dc9bd86a2a7f5$var$h(), $155dc9bd86a2a7f5$var$y();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $155dc9bd86a2a7f5$var$m;
        }
    };
}, $155dc9bd86a2a7f5$var$C = function(e) {
    document.prerendering ? addEventListener("prerenderingchange", function() {
        return e();
    }, !0) : e();
}, $155dc9bd86a2a7f5$export$e610c735b5510cec = [
    1800,
    3e3
], $155dc9bd86a2a7f5$export$52489892712e8192 = function(e, n) {
    n = n || {}, $155dc9bd86a2a7f5$var$C(function() {
        var t, r = $155dc9bd86a2a7f5$var$E(), i = $155dc9bd86a2a7f5$var$f("FCP"), a = $155dc9bd86a2a7f5$var$s("paint", function(e) {
            e.forEach(function(e) {
                "first-contentful-paint" === e.name && (a.disconnect(), e.startTime < r.firstHiddenTime && (i.value = Math.max(e.startTime - $155dc9bd86a2a7f5$var$u(), 0), i.entries.push(e), t(!0)));
            });
        });
        a && (t = $155dc9bd86a2a7f5$var$d(e, i, $155dc9bd86a2a7f5$export$e610c735b5510cec, n.reportAllChanges), $155dc9bd86a2a7f5$var$o(function(r) {
            i = $155dc9bd86a2a7f5$var$f("FCP"), t = $155dc9bd86a2a7f5$var$d(e, i, $155dc9bd86a2a7f5$export$e610c735b5510cec, n.reportAllChanges), $155dc9bd86a2a7f5$var$l(function() {
                i.value = performance.now() - r.timeStamp, t(!0);
            });
        }));
    });
}, $155dc9bd86a2a7f5$export$3f20d8e089ac35b2 = [
    .1,
    .25
], $155dc9bd86a2a7f5$export$fc6227831ee7c7 = function(e, n) {
    n = n || {}, $155dc9bd86a2a7f5$export$52489892712e8192($155dc9bd86a2a7f5$var$v(function() {
        var t, r = $155dc9bd86a2a7f5$var$f("CLS", 0), i = 0, a = [], c = function(e) {
            e.forEach(function(e) {
                if (!e.hadRecentInput) {
                    var n = a[0], t = a[a.length - 1];
                    i && e.startTime - t.startTime < 1e3 && e.startTime - n.startTime < 5e3 ? (i += e.value, a.push(e)) : (i = e.value, a = [
                        e
                    ]);
                }
            }), i > r.value && (r.value = i, r.entries = a, t());
        }, u = $155dc9bd86a2a7f5$var$s("layout-shift", c);
        u && (t = $155dc9bd86a2a7f5$var$d(e, r, $155dc9bd86a2a7f5$export$3f20d8e089ac35b2, n.reportAllChanges), $155dc9bd86a2a7f5$var$p(function() {
            c(u.takeRecords()), t(!0);
        }), $155dc9bd86a2a7f5$var$o(function() {
            i = 0, r = $155dc9bd86a2a7f5$var$f("CLS", 0), t = $155dc9bd86a2a7f5$var$d(e, r, $155dc9bd86a2a7f5$export$3f20d8e089ac35b2, n.reportAllChanges), $155dc9bd86a2a7f5$var$l(function() {
                return t();
            });
        }), setTimeout(t, 0));
    }));
}, $155dc9bd86a2a7f5$var$A = {
    passive: !0,
    capture: !0
}, $155dc9bd86a2a7f5$var$I = new Date, $155dc9bd86a2a7f5$var$P = function(r, i) {
    $155dc9bd86a2a7f5$var$e || ($155dc9bd86a2a7f5$var$e = i, $155dc9bd86a2a7f5$var$n = r, $155dc9bd86a2a7f5$var$t = new Date, $155dc9bd86a2a7f5$var$k(removeEventListener), $155dc9bd86a2a7f5$var$F());
}, $155dc9bd86a2a7f5$var$F = function() {
    if ($155dc9bd86a2a7f5$var$n >= 0 && $155dc9bd86a2a7f5$var$n < $155dc9bd86a2a7f5$var$t - $155dc9bd86a2a7f5$var$I) {
        var i = {
            entryType: "first-input",
            name: $155dc9bd86a2a7f5$var$e.type,
            target: $155dc9bd86a2a7f5$var$e.target,
            cancelable: $155dc9bd86a2a7f5$var$e.cancelable,
            startTime: $155dc9bd86a2a7f5$var$e.timeStamp,
            processingStart: $155dc9bd86a2a7f5$var$e.timeStamp + $155dc9bd86a2a7f5$var$n
        };
        $155dc9bd86a2a7f5$var$r.forEach(function(e) {
            e(i);
        }), $155dc9bd86a2a7f5$var$r = [];
    }
}, $155dc9bd86a2a7f5$var$M = function(e) {
    if (e.cancelable) {
        var n = (e.timeStamp > 1e12 ? new Date : performance.now()) - e.timeStamp;
        "pointerdown" == e.type ? function(e, n) {
            var t = function() {
                $155dc9bd86a2a7f5$var$P(e, n), i();
            }, r = function() {
                i();
            }, i = function() {
                removeEventListener("pointerup", t, $155dc9bd86a2a7f5$var$A), removeEventListener("pointercancel", r, $155dc9bd86a2a7f5$var$A);
            };
            addEventListener("pointerup", t, $155dc9bd86a2a7f5$var$A), addEventListener("pointercancel", r, $155dc9bd86a2a7f5$var$A);
        }(n, e) : $155dc9bd86a2a7f5$var$P(n, e);
    }
}, $155dc9bd86a2a7f5$var$k = function(e) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(n) {
        return e(n, $155dc9bd86a2a7f5$var$M, $155dc9bd86a2a7f5$var$A);
    });
}, $155dc9bd86a2a7f5$export$8f7f3c48ca6fbe34 = [
    100,
    300
], $155dc9bd86a2a7f5$export$134ed2977d320dfd = function(t, i) {
    i = i || {}, $155dc9bd86a2a7f5$var$C(function() {
        var a, c = $155dc9bd86a2a7f5$var$E(), u = $155dc9bd86a2a7f5$var$f("FID"), l = function(e) {
            e.startTime < c.firstHiddenTime && (u.value = e.processingStart - e.startTime, u.entries.push(e), a(!0));
        }, m = function(e) {
            e.forEach(l);
        }, h = $155dc9bd86a2a7f5$var$s("first-input", m);
        a = $155dc9bd86a2a7f5$var$d(t, u, $155dc9bd86a2a7f5$export$8f7f3c48ca6fbe34, i.reportAllChanges), h && $155dc9bd86a2a7f5$var$p($155dc9bd86a2a7f5$var$v(function() {
            m(h.takeRecords()), h.disconnect();
        })), h && $155dc9bd86a2a7f5$var$o(function() {
            var o;
            u = $155dc9bd86a2a7f5$var$f("FID"), a = $155dc9bd86a2a7f5$var$d(t, u, $155dc9bd86a2a7f5$export$8f7f3c48ca6fbe34, i.reportAllChanges), $155dc9bd86a2a7f5$var$r = [], $155dc9bd86a2a7f5$var$n = -1, $155dc9bd86a2a7f5$var$e = null, $155dc9bd86a2a7f5$var$k(addEventListener), o = l, $155dc9bd86a2a7f5$var$r.push(o), $155dc9bd86a2a7f5$var$F();
        });
    });
}, $155dc9bd86a2a7f5$var$B = 0, $155dc9bd86a2a7f5$var$R = 1 / 0, $155dc9bd86a2a7f5$var$H = 0, $155dc9bd86a2a7f5$var$N = function(e) {
    e.forEach(function(e) {
        e.interactionId && ($155dc9bd86a2a7f5$var$R = Math.min($155dc9bd86a2a7f5$var$R, e.interactionId), $155dc9bd86a2a7f5$var$H = Math.max($155dc9bd86a2a7f5$var$H, e.interactionId), $155dc9bd86a2a7f5$var$B = $155dc9bd86a2a7f5$var$H ? ($155dc9bd86a2a7f5$var$H - $155dc9bd86a2a7f5$var$R) / 7 + 1 : 0);
    });
}, $155dc9bd86a2a7f5$var$O = function() {
    return $155dc9bd86a2a7f5$var$i ? $155dc9bd86a2a7f5$var$B : performance.interactionCount || 0;
}, $155dc9bd86a2a7f5$var$q = function() {
    "interactionCount" in performance || $155dc9bd86a2a7f5$var$i || ($155dc9bd86a2a7f5$var$i = $155dc9bd86a2a7f5$var$s("event", $155dc9bd86a2a7f5$var$N, {
        type: "event",
        buffered: !0,
        durationThreshold: 0
    }));
}, $155dc9bd86a2a7f5$export$7f4cb060ded9173c = [
    200,
    500
], $155dc9bd86a2a7f5$var$_ = 0, $155dc9bd86a2a7f5$var$z = function() {
    return $155dc9bd86a2a7f5$var$O() - $155dc9bd86a2a7f5$var$_;
}, $155dc9bd86a2a7f5$var$G = [], $155dc9bd86a2a7f5$var$J = {}, $155dc9bd86a2a7f5$var$K = function(e) {
    var n = $155dc9bd86a2a7f5$var$G[$155dc9bd86a2a7f5$var$G.length - 1], t = $155dc9bd86a2a7f5$var$J[e.interactionId];
    if (t || $155dc9bd86a2a7f5$var$G.length < 10 || e.duration > n.latency) {
        if (t) t.entries.push(e), t.latency = Math.max(t.latency, e.duration);
        else {
            var r = {
                id: e.interactionId,
                latency: e.duration,
                entries: [
                    e
                ]
            };
            $155dc9bd86a2a7f5$var$J[r.id] = r, $155dc9bd86a2a7f5$var$G.push(r);
        }
        $155dc9bd86a2a7f5$var$G.sort(function(e, n) {
            return n.latency - e.latency;
        }), $155dc9bd86a2a7f5$var$G.splice(10).forEach(function(e) {
            delete $155dc9bd86a2a7f5$var$J[e.id];
        });
    }
}, $155dc9bd86a2a7f5$export$6693a9916ea977ef = function(e, n) {
    n = n || {}, $155dc9bd86a2a7f5$var$C(function() {
        var t;
        $155dc9bd86a2a7f5$var$q();
        var r, i = $155dc9bd86a2a7f5$var$f("INP"), a = function(e) {
            e.forEach(function(e) {
                (e.interactionId && $155dc9bd86a2a7f5$var$K(e), "first-input" === e.entryType) && !$155dc9bd86a2a7f5$var$G.some(function(n) {
                    return n.entries.some(function(n) {
                        return e.duration === n.duration && e.startTime === n.startTime;
                    });
                }) && $155dc9bd86a2a7f5$var$K(e);
            });
            var n, t = (n = Math.min($155dc9bd86a2a7f5$var$G.length - 1, Math.floor($155dc9bd86a2a7f5$var$z() / 50)), $155dc9bd86a2a7f5$var$G[n]);
            t && t.latency !== i.value && (i.value = t.latency, i.entries = t.entries, r());
        }, c = $155dc9bd86a2a7f5$var$s("event", a, {
            durationThreshold: null !== (t = n.durationThreshold) && void 0 !== t ? t : 40
        });
        r = $155dc9bd86a2a7f5$var$d(e, i, $155dc9bd86a2a7f5$export$7f4cb060ded9173c, n.reportAllChanges), c && ("interactionId" in PerformanceEventTiming.prototype && c.observe({
            type: "first-input",
            buffered: !0
        }), $155dc9bd86a2a7f5$var$p(function() {
            a(c.takeRecords()), i.value < 0 && $155dc9bd86a2a7f5$var$z() > 0 && (i.value = 0, i.entries = []), r(!0);
        }), $155dc9bd86a2a7f5$var$o(function() {
            $155dc9bd86a2a7f5$var$G = [], $155dc9bd86a2a7f5$var$_ = $155dc9bd86a2a7f5$var$O(), i = $155dc9bd86a2a7f5$var$f("INP"), r = $155dc9bd86a2a7f5$var$d(e, i, $155dc9bd86a2a7f5$export$7f4cb060ded9173c, n.reportAllChanges);
        }));
    });
}, $155dc9bd86a2a7f5$export$948521ca5b0e1b17 = [
    2500,
    4e3
], $155dc9bd86a2a7f5$var$V = {}, $155dc9bd86a2a7f5$export$da982ced0ff8a670 = function(e, n) {
    n = n || {}, $155dc9bd86a2a7f5$var$C(function() {
        var t, r = $155dc9bd86a2a7f5$var$E(), i = $155dc9bd86a2a7f5$var$f("LCP"), a = function(e) {
            var n = e[e.length - 1];
            n && n.startTime < r.firstHiddenTime && (i.value = Math.max(n.startTime - $155dc9bd86a2a7f5$var$u(), 0), i.entries = [
                n
            ], t());
        }, c = $155dc9bd86a2a7f5$var$s("largest-contentful-paint", a);
        if (c) {
            t = $155dc9bd86a2a7f5$var$d(e, i, $155dc9bd86a2a7f5$export$948521ca5b0e1b17, n.reportAllChanges);
            var m = $155dc9bd86a2a7f5$var$v(function() {
                $155dc9bd86a2a7f5$var$V[i.id] || (a(c.takeRecords()), c.disconnect(), $155dc9bd86a2a7f5$var$V[i.id] = !0, t(!0));
            });
            [
                "keydown",
                "click"
            ].forEach(function(e) {
                addEventListener(e, function() {
                    return setTimeout(m, 0);
                }, !0);
            }), $155dc9bd86a2a7f5$var$p(m), $155dc9bd86a2a7f5$var$o(function(r) {
                i = $155dc9bd86a2a7f5$var$f("LCP"), t = $155dc9bd86a2a7f5$var$d(e, i, $155dc9bd86a2a7f5$export$948521ca5b0e1b17, n.reportAllChanges), $155dc9bd86a2a7f5$var$l(function() {
                    i.value = performance.now() - r.timeStamp, $155dc9bd86a2a7f5$var$V[i.id] = !0, t(!0);
                });
            });
        }
    });
}, $155dc9bd86a2a7f5$export$65c59ea8064668fc = [
    800,
    1800
], $155dc9bd86a2a7f5$var$Y = function e(n) {
    document.prerendering ? $155dc9bd86a2a7f5$var$C(function() {
        return e(n);
    }) : "complete" !== document.readyState ? addEventListener("load", function() {
        return e(n);
    }, !0) : setTimeout(n, 0);
}, $155dc9bd86a2a7f5$export$6e8eea9a35032c92 = function(e, n) {
    n = n || {};
    var t = $155dc9bd86a2a7f5$var$f("TTFB"), r = $155dc9bd86a2a7f5$var$d(e, t, $155dc9bd86a2a7f5$export$65c59ea8064668fc, n.reportAllChanges);
    $155dc9bd86a2a7f5$var$Y(function() {
        var i = $155dc9bd86a2a7f5$var$c();
        if (i) {
            var a = i.responseStart;
            if (a <= 0 || a > performance.now()) return;
            t.value = Math.max(a - $155dc9bd86a2a7f5$var$u(), 0), t.entries = [
                i
            ], r(!0), $155dc9bd86a2a7f5$var$o(function() {
                t = $155dc9bd86a2a7f5$var$f("TTFB", 0), (r = $155dc9bd86a2a7f5$var$d(e, t, $155dc9bd86a2a7f5$export$65c59ea8064668fc, n.reportAllChanges))(!0);
            });
        }
    });
};


function $0026cc5aa8359700$var$getNavigationMetrics() {
    let result = [];
    try {
        result = window.performance.getEntriesByType("navigation");
    } catch (error) {
        console.error(error);
    }
    return result;
}
/**
 * logToServer
 * 
 * Function to log the web vitals to the server using fetch or navigator.sendBeacon
 * it should also include the user agent and the current url
 */ async function $0026cc5aa8359700$var$logToServer(analyticsEvent) {
    try {
        analyticsEvent["userAgent"] = navigator.userAgent;
        analyticsEvent["url"] = window.location.href;
        if (analyticsEvent["name"] === "LCP") analyticsEvent["navigation"] = $0026cc5aa8359700$var$getNavigationMetrics();
        const url = "/webvitals/";
        const options = {
            method: "POST",
            body: JSON.stringify(analyticsEvent),
            mode: "same-origin",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        };
        const response = await fetch(url, options);
        if (!response.ok) throw new Error(`Failed to log web vitals to server: ${response.status} ${response.statusText}`);
        return response.json();
    } catch (error) {
        console.error(error);
    }
}
(0, $155dc9bd86a2a7f5$export$fc6227831ee7c7)($0026cc5aa8359700$var$logToServer);
(0, $155dc9bd86a2a7f5$export$134ed2977d320dfd)($0026cc5aa8359700$var$logToServer);
(0, $155dc9bd86a2a7f5$export$da982ced0ff8a670)($0026cc5aa8359700$var$logToServer);

})();
//# sourceMappingURL=main.js.map
